/* OnePod homepage: product finder, cart integration, delivery copy, and animations. */
(function () {
  'use strict';
  /* Keep editor-driven section reloads from initializing the bundle twice. */
  if (window.__ophBoot) return;
  window.__ophBoot = true;
  var CAT = window.OP_CAT;

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* "119,95 €", the same format as the product pages (HF-10) */
  var EUR = (typeof Intl !== 'undefined' && Intl.NumberFormat) ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }) : null;
  function euro(cents) { var n = cents / 100; return EUR ? EUR.format(n) : n.toFixed(2).replace('.', ',') + '\u00a0€'; }
  /* Inline arrow (not the U+2192 glyph, which the self-hosted font subsets lack; see PERF-04). */
  var ARROW = '<svg class="oph-arrow" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3.5 10h13M11 4.5l5.5 5.5-5.5 5.5"/></svg>';
  var CHECK = '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="#1B7F4D" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 10.5 8.5 15 16 5.5"></polyline></svg>';

  function bezorg() {
    if (window.onePodDeliveryPromise) return window.onePodDeliveryPromise();
    return { short: 'Livraison calculée au paiement', long: 'Livraison calculée au paiement' };
  }

  /* ---------- winkelwagen ---------- */
  function cartAdd(variantId, button) {
    if (button) { button.classList.add('is-wait'); button.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'échec de l’ajout'); });
      return r.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('onepod:basket-sync', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('onepod:basket-open', { bubbles: true }));
    }).catch(function (e) {
      alert('Une erreur est survenue : ' + e.message);
    }).finally(function () {
      if (button) { button.classList.remove('is-wait'); button.disabled = false; }
    });
  }

  /* ---------- reveal-animaties ---------- */
  function reveal() {
    var els = document.querySelectorAll('.oph-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- FAQ ---------- */
  function faq() {
    document.querySelectorAll('[data-oph-faq]').forEach(function (wrap) {
      wrap.querySelectorAll('.oph-faq__item').forEach(function (item) {
        var button = item.querySelector('.oph-faq__q');
        var ans = item.querySelector('.oph-faq__a');
        button.addEventListener('click', function () {
          var open = !ans.hidden;
          wrap.querySelectorAll('.oph-faq__a').forEach(function (a) { a.hidden = true; });
          wrap.querySelectorAll('.oph-faq__item').forEach(function (i) { i.classList.remove('is-open'); });
          wrap.querySelectorAll('.oph-faq__q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
          if (!open) { ans.hidden = false; item.classList.add('is-open'); button.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  /* ---------- productkaarten (populair) ---------- */
  function pcards() {
    document.querySelectorAll('[data-oph-pcard]').forEach(function (card) {
      var addBtn = card.querySelector('.oph-pcard__add');
      var varsEl = card.querySelector('.oph-pcard__vars');
      var pills = card.querySelectorAll('.oph-pcard__var');
      var price = card.querySelector('.oph-pcard__price');
      var sel = null;
      if (pills.length) {
        pills.forEach(function (p) {
          p.addEventListener('click', function () {
            pills.forEach(function (x) { x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false'); });
            p.classList.add('is-sel'); p.setAttribute('aria-pressed', 'true');
            sel = p;
            if (price && p.dataset.price) price.textContent = p.dataset.price;
            if (p.dataset.productUrl) {
              card.querySelectorAll('[data-oph-product-link]').forEach(function (link) { link.href = p.dataset.productUrl; });
            }
            var stock = card.querySelector('[data-oph-stock]');
            var ship = card.querySelector('[data-oph-ship]');
            if (stock) {
              stock.classList.remove('is-ok', 'is-order', 'is-out');
              stock.classList.add('is-' + p.dataset.stockState);
              stock.textContent = p.dataset.stockLabel;
              stock.prepend(document.createElement('i'));
            }
            if (ship) {
              ship.textContent = p.dataset.shipLabel;
              ship.hidden = !p.dataset.shipLabel;
            }
            if (varsEl) varsEl.classList.remove('is-attn');
            if (addBtn) {
              var kan = p.dataset.beschikbaar === '1';
              addBtn.textContent = kan ? 'Ajouter au panier' : 'Épuisé';
              addBtn.classList.toggle('is-out', !kan);
              addBtn.classList.remove('is-wait');
              addBtn.setAttribute('aria-disabled', kan ? 'false' : 'true');
              addBtn.disabled = false;
            }
          });
        });
      }
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.classList.contains('is-out') || addBtn.classList.contains('is-wait')) return;
          var vid;
          if (pills.length) {
            if (!sel) {
              /* The button is aria-disabled, not disabled, so a press lands here: point at the
                 chips (accent outline) and move focus to the first one instead of doing nothing. */
              if (varsEl) varsEl.classList.add('is-attn');
              pills[0].focus();
              return;
            }
            vid = sel.dataset.variant;
          } else {
            vid = addBtn.dataset.variant;
          }
          if (vid) cartAdd(vid, addBtn);
        });
      }
    });
  }

  /* ============================================================
     Finder
     ============================================================ */
  function finder(root) {
    var S = { step: 1, part: null, brand: null, model: null, optIdx: null, done: false, mnrOpen: false, na: null, naSoort: null, prod: null, laden: false, fout: null, seq: 0 };
    var $ = function (s) { return root.querySelector(s); };
    var titelEl = $('[data-f-title]'), stapEl = $('[data-f-step]'), meterEl = $('[data-f-meter]');
    var crumbsEl = $('[data-f-crumbs]'), paneEl = $('[data-f-pane]'), backBtn = $('[data-f-back]');

    function brand() { return CAT.brands.find(function (b) { return b.id === S.brand; }) || null; }
    function model() { var b = brand(); if (!b) return null; return b.models.find(function (m) { return m.id === S.model; }) || null; }
    function opties() { var m = model(); if (!m || !m.parts) return null; return m.parts[S.part] || null; }
    /* Total steps, fixed as soon as the brand (and part) is known, so the counter never jumps from
       "3 sur 3" to "4 sur 4" when a version question appears (HF-10). */
    function totaal() {
      var b = brand();
      if (!b) return 3;
      var heeftVersie = b.models.some(function (m) {
        if (!m.parts) return false;
        var keys = S.part ? [S.part] : Object.keys(m.parts);
        return keys.some(function (k) { var o = m.parts[k]; return !!(o && o.length > 1); });
      });
      return heeftVersie ? 4 : 3;
    }
    var eersteRender = true;

    /* Model search (brands with many models): accent-insensitive match on the name and the
       manufacturer codes from op-catalogus.js, spaces optional ("tune230" finds "Tune 230"). */
    function norm(v) { return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
    function modelMatch(m, q) {
      if (!q) return true;
      var hay = norm(m.name) + ' ' + norm((m.codes || []).join(' '));
      var compact = hay.replace(/ /g, '');
      return compact.indexOf(q.replace(/ /g, '')) >= 0 || q.split(' ').every(function (tok) { return hay.indexOf(tok) >= 0; });
    }

    function partLabel(p) { return CAT.parts[p] || ''; }

    /* ---- productdata live ophalen (met staleness-guard: late antwoorden van een
       eerdere selectie mogen de state niet meer overschrijven) ---- */
    function laadProduct(optie) {
      var mijn = ++S.seq;
      S.laden = true; S.prod = null; S.fout = null;
      render();
      fetch('/products/' + optie.h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (p) {
          if (mijn !== S.seq) return;
          var v = null;
          if (optie.vt) {
            v = p.variants.find(function (x) { return x.title.indexOf(optie.vt) >= 0; }) || null;
          }
          /* meerdere varianten zonder expliciete keuze (kleur/firmware, bijv. Sony
             WF-1000XM5): dan NIET blind toevoegen maar naar de productpagina sturen */
          var moetKiezen = !optie.vt && p.variants.length > 1;
          if (!v) v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
          S.prod = {
            handle: optie.h, url: p.url, titel: p.title,
            img: (p.featured_image || (p.images && p.images[0]) || '') + '',
            variantId: v ? v.id : null,
            prijs: v ? v.price : p.price,
            prijsVanaf: !!p.price_varies,
            beschikbaar: !optie.retired && (moetKiezen ? p.available : (v ? v.available : p.available)),
            stockOnly: optie.stockOnly,
            retired: optie.retired,
            /* Op voorraad != te koop. Alles is te koop; alleen wat we echt hebben liggen mag een
               levering van 1 tot 2 dagen beloven. De vlag komt uit op-catalogus.js, want
               /products/<handle>.js geeft geen voorraadaantal terug. */
            opVoorraad: optie.s === 1,
            variantTitel: optie.vt || null,
            kies: moetKiezen,
          };
          S.laden = false; render();
        })
        .catch(function (e) {
          if (mijn !== S.seq) return;
          S.laden = false;
          if (String(e && e.message) === '404') {
            S.naSoort = 'netniet';
            S.na = 'Cette pièce n’est pas disponible en ligne actuellement. Envoyez-nous votre numéro de modèle : nous vérifierons notre stock, qui peut être plus large que notre catalogue en ligne.';
          } else {
            S.fout = optie; /* tijdelijke storing: opnieuw kunnen proberen */
          }
          render();
        });
    }

    function kiesModel(m) {
      if (m.na) { S.model = m.id; S.na = m.na; S.naSoort = 'firmware'; render(); return; }
      S.model = m.id; S.na = null; S.naSoort = null;
      var o = m.parts ? m.parts[S.part] : null;
      if (!o || !o.length) {
        if (S.part === 'T') {
          S.naSoort = 'tips';
          S.na = 'Nous ne proposons pas d’embouts séparés en ligne pour ce modèle. Consultez les accessoires ou contactez-nous pour connaître les possibilités.';
        } else {
          S.naSoort = 'netniet';
          S.na = 'Cette pièce n’est pas proposée en ligne pour ce modèle. Envoyez-nous votre numéro de modèle : notre stock peut être plus large que notre catalogue en ligne.';
        }
        render(); return;
      }
      if (o.length > 1) { S.step = 4; render(); return; }
      S.optIdx = 0; S.done = true; laadProduct(o[0]);
    }

    function mnrZoek(val) {
      var v = (val || '').trim().toUpperCase().replace(/\s/g, '');
      if (!v) return false;
      var hit = CAT.mnr[v];
      if (hit) {
        if (hit.na) { S.na = hit.na; S.naSoort = 'firmware'; S.brand = 'apple'; render(); return true; }
        if (hit.caseOnly && S.part !== 'C') {
          /* A1602 / A1938 are the case numbers of AirPods 1 and 2 alike: they cannot identify the earbud generation */
          S.brand = 'apple'; S.naSoort = 'netniet';
          S.na = 'Ce numéro est celui du boîtier, commun aux AirPods 1 et 2. Pour l’écouteur, relevez le numéro inscrit sur l’écouteur lui-même (par exemple A2032 pour les AirPods 2).';
          render(); return true;
        }
        S.brand = 'apple';
        var b = brand();
        var m = b.models.find(function (x) { return x.id === hit.model; });
        if (!m) return false;
        S.model = m.id; S.na = null;
        var o = m.parts ? m.parts[S.part] : null;
        if (!o || !o.length) { kiesModel(m); return true; }
        var idx = 0;
        if (hit.vt) {
          var gevonden = o.findIndex(function (x) { return x.vt === hit.vt; });
          if (gevonden >= 0) idx = gevonden;
          else if (o.length > 1) { S.step = 4; render(); return true; }
        } else if (hit.label && S.part === 'C') {
          /* the code names one case version (AirPods 3 Lightning / MagSafe) */
          var perLabel = o.findIndex(function (x) { return x.label === hit.label; });
          if (perLabel >= 0) idx = perLabel;
          else if (o.length > 1) { S.step = 4; render(); return true; }
        } else if (o.length > 1) { S.step = 4; render(); return true; }
        S.optIdx = idx; S.done = true; laadProduct(o[idx]);
        return true;
      }
      /* overige merken: zoek in de codes van alle modellen */
      for (var bi = 0; bi < CAT.brands.length; bi++) {
        var bb = CAT.brands[bi];
        for (var mi = 0; mi < bb.models.length; mi++) {
          var mm = bb.models[mi];
          if ((mm.codes || []).some(function (c) { return String(c).toUpperCase() === v; })) {
            S.brand = bb.id; kiesModel(mm); return true;
          }
        }
      }
      return false;
    }

    /* ---- render ---- */
    function render() {
      var st = S.done || S.na ? 99 : S.step;
      var tot = totaal();
      var getoond = Math.min(S.step, tot);
      var titels = { 1: 'Que vous manque-t-il ?', 2: 'Quelle est votre marque ?', 3: 'Quel est votre modèle ?', 4: 'Quelle version possédez-vous ?' };
      var m = model();
      if (st === 4 && m && m.vraag) titels[4] = m.vraag;

      var naTitels = { firmware: 'Ce modèle n’est volontairement pas vendu en ligne', tips: 'Embouts séparés : vérifions ensemble', netniet: 'Non disponible en ligne : nous pouvons vous aider' };
      if (S.fout) titelEl.textContent = 'Une erreur est survenue';
      else titelEl.textContent = S.na ? (naTitels[S.naSoort] || naTitels.netniet) : (S.done ? 'Modèle et pièce identifiés' : titels[Math.min(S.step, 4)]);
      stapEl.textContent = S.done || S.na || S.fout ? 'Étape ' + tot + ' sur ' + tot : 'Étape ' + getoond + ' sur ' + tot;
      meterEl.style.width = (S.done || S.na) ? '100%' : (Math.round(((getoond - 1) / tot) * 100) + 8) + '%';

      /* kruimels */
      var crumbs = [];
      if (S.part) crumbs.push({ lbl: partLabel(S.part), go: function () { S.seq++; Object.assign(S, { step: 1, part: null, brand: null, model: null, optIdx: null, done: false, na: null, naSoort: null, prod: null, fout: null, laden: false, mnrOpen: false }); render(); } });
      if (S.brand) crumbs.push({ lbl: (brand() || {}).name, go: function () { S.seq++; Object.assign(S, { step: 2, brand: null, model: null, optIdx: null, done: false, na: null, naSoort: null, prod: null, fout: null, laden: false, mnrOpen: false }); render(); } });
      if (S.model && (S.done || S.na || S.fout || S.step > 3)) crumbs.push({ lbl: (model() || { name: S.model }).name, go: function () { S.seq++; Object.assign(S, { step: 3, model: null, optIdx: null, done: false, na: null, naSoort: null, prod: null, fout: null, laden: false }); render(); } });
      crumbsEl.innerHTML = '';
      crumbsEl.hidden = crumbs.length === 0;
      crumbs.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'oph-crumbchip';
        b.setAttribute('aria-label', 'Retirer le choix ' + c.lbl);
        b.innerHTML = esc(c.lbl) + '<i aria-hidden="true">✕</i>';
        b.addEventListener('click', c.go);
        crumbsEl.appendChild(b);
      });

      backBtn.hidden = S.done || S.na || S.fout ? false : S.step === 1;
      paneEl.innerHTML = maakPane();
      koppelPane();
      /* After a choice the pane is rebuilt and focus would fall to <body>; move it to the question
         (tabindex="-1") so keyboard users continue from here and screen readers hear the new step.
         Not on the initial render: that would steal focus on page load. */
      if (!eersteRender) titelEl.focus();
      eersteRender = false;
    }

    function maakPane() {
      if (S.fout) return paneFout();
      if (S.na) return paneNa();
      if (S.done) return paneResultaat();
      if (S.step === 1) return panePart();
      if (S.step === 2) return paneBrand();
      if (S.step === 3) return paneModel();
      if (S.step === 4) return paneVariant();
      return '';
    }

    function panePart() {
      var arrow = '<span class="oph-partbtn__arrow" aria-hidden="true">' + ARROW + '</span>';
      var items = [
        { g: 'L', t: 'Écouteur gauche', s: 'Uniquement l’écouteur gauche' },
        { g: 'R', t: 'Écouteur droit', s: 'Uniquement l’écouteur droit' },
        { g: 'C', t: 'Boîtier de charge', s: 'Boîtier perdu ou défectueux' },
        { g: 'T', t: 'Embouts', s: 'Embouts et petits accessoires' },
      ];
      return '<div class="oph-finder__parts">' + items.map(function (i) {
        return '<button type="button" class="oph-partbtn" data-part="' + i.g + '">'
          + '<span class="oph-partbtn__glyph">' + i.g + '</span>'
          + '<span><span class="oph-partbtn__t">' + i.t + '</span><span class="oph-partbtn__s">' + i.s + '</span></span>'
          + arrow + '</button>';
      }).join('') + '</div>';
    }

    function paneBrand() {
      return '<div class="oph-finder__brands">' + CAT.brands.map(function (b) {
        var binnen = b.logo ? '<img src="' + esc(b.logo) + '" alt="' + esc(b.name) + '" loading="lazy">' : '<b>' + esc(b.name) + '</b>';
        return '<button type="button" class="oph-brandbtn" data-brand="' + esc(b.id) + '" title="' + esc(b.name + ' — ' + (b.sub || '')) + '">' + binnen + '</button>';
      }).join('') + '</div>'
        + '<p class="oph-finder__note">Votre marque ne figure pas dans la liste ? <a href="mailto:contact@onepod.fr">Contactez-nous</a> : notre stock peut être plus large que notre catalogue en ligne.</p>';
    }

    function modelTegels(models) {
      var alle = brand().models;
      return models.map(function (m) {
        var i = alle.indexOf(m);
        var img = m.img ? '<img src="' + esc(m.img) + '" alt="" loading="lazy">' : '';
        return '<button type="button" class="oph-modelbtn' + (m.na ? ' oph-modelbtn--na' : '') + '" data-model="' + i + '">' + img + '<span>' + esc(m.name) + '</span></button>';
      }).join('');
    }

    function paneModel() {
      var b = brand();
      if (!b) return '';
      /* Brands with many models (JBL 50, Jabra 17, OnePlus 14, Sony 13) get a search field and the
         "je ne connais pas mon modèle" help pinned above the tiles instead of seven screens below (HF-06). */
      var groot = b.models.length > 12;
      var zoek = '';
      if (groot) {
        var voorbeeld = b.models[Math.floor(b.models.length / 2)].name;
        zoek = '<div class="oph-finder__search"><label class="oph-mnr__lbl" for="oph-model-search">Rechercher un modèle</label>'
          + '<input id="oph-model-search" class="oph-mnr__input" type="text" inputmode="search" autocomplete="off" spellcheck="false" placeholder="ex. ' + esc(voorbeeld) + '" data-model-search></div>';
      }
      var grid = '<div class="oph-finder__models" data-model-grid>' + modelTegels(b.models) + '</div>'
        + (groot ? '<p class="oph-finder__note" data-model-empty hidden>Aucun modèle ne correspond. Essayez le numéro de modèle ci-dessus ou <a href="mailto:contact@onepod.fr">contactez-nous</a>.</p>' : '');
      var mnr = '';
      var heeftCodes = b.id === 'apple' || b.models.some(function (m) { return (m.codes || []).length; });
      if (heeftCodes) {
        mnr = '<div class="oph-mnr' + (groot ? ' oph-mnr--top' : '') + '">'
          + '<button type="button" class="oph-mnr__toggle" data-mnr-toggle aria-expanded="' + (S.mnrOpen ? 'true' : 'false') + '">Je ne connais pas mon modèle : l’identifier avec le numéro de l’autre écouteur'
          + ' <svg width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 4 13 10 6 16"></polyline></svg></button>'
          + '<div class="oph-mnr__panel"' + (S.mnrOpen ? '' : ' hidden') + ' data-mnr-panel>'
          + '<div><p class="oph-mnr__h">Trouvez votre numéro de modèle en 10 secondes</p>'
          + (b.id === 'apple'
            ? '<p class="oph-mnr__s">Sur votre iPhone, avec vos AirPods connectés :</p><ol class="oph-mnr__steps"><li><i>1</i><span>Ouvrez <strong>Réglages</strong> ' + ARROW + ' <strong>Bluetooth</strong></span></li><li><i>2</i><span>Touchez le <strong>ⓘ</strong> à côté de vos AirPods</span></li><li><i>3</i><span>Faites défiler jusqu’à <strong>Numéro du modèle</strong></span></li></ol><p class="oph-mnr__fine">Le numéro figure également en petits caractères sur l’autre écouteur et sous le boîtier de charge. Voir aussi le <a href="/pages/identifier-generation-airpods">guide pour identifier la génération</a>.</p>'
            : '<p class="oph-mnr__s">Le numéro de modèle figure en petits caractères sur votre <strong>autre écouteur</strong> et sous le boîtier de charge.</p>')
          + '</div>'
          + '<div><label class="oph-mnr__lbl" for="oph-mnr-input">Numéro du modèle</label>'
          + '<div class="oph-mnr__row"><input id="oph-mnr-input" class="oph-mnr__input" data-mnr-input placeholder="' + (b.id === 'apple' ? 'ex. A2698' : 'ex. ' + esc((b.models.find(function (m) { return (m.codes || []).length; }) || { codes: ['…'] }).codes[0])) + '" autocomplete="off">'
          + '<button type="button" class="oph-mnr__go" data-mnr-go>Identifier le modèle</button></div>'
          + '<p class="oph-mnr__fail" data-mnr-fail hidden>Ce numéro n’est pas encore reconnu. <a href="mailto:contact@onepod.fr?subject=Quelle%20pi%C3%A8ce%20est%20compatible%20%3F%20(num%C3%A9ro%20de%20mod%C3%A8le%20%3A%20)">Envoyez-nous votre numéro de modèle</a> : nous trouverons la pièce adaptée.</p>'
          + '</div></div></div>';
      }
      return groot ? zoek + mnr + grid : grid + mnr;
    }

    function paneVariant() {
      var o = opties() || [];
      var knoppen = '<div class="oph-finder__vars">' + o.map(function (x, i) {
        return '<button type="button" class="oph-varbtn" data-opt="' + i + '"><span class="oph-varbtn__t">' + esc(x.label || x.badge || 'Version ' + (i + 1)) + '</span><span class="oph-varbtn__s">' + esc(x.sub || '') + '</span></button>';
      }).join('') + '</div>';
      var m = model();
      var hulp = '';
      if (m && m.id === 'pro2') {
        hulp = '<div class="oph-caseshelp"><button type="button" class="oph-caseshelp__t" data-casehelp-toggle>Je ne sais pas</button>'
          + '<p class="oph-caseshelp__p" data-casehelp hidden>Regardez le port sous votre boîtier : le connecteur <strong>USB-C</strong> est ovale et large, tandis que le connecteur <strong>Lightning</strong> est étroit avec des angles arrondis. En cas de doute, vérifiez le numéro de modèle sous le boîtier ou <a href="mailto:contact@onepod.fr">contactez-nous</a>.</p></div>';
      }
      return knoppen + hulp;
    }

    function paneFout() {
      return '<div class="oph-finder__na"><h3>Connexion momentanément indisponible</h3>'
        + '<p>Le stock actuel n’a pas pu être chargé. Le problème vient de la connexion, pas de votre sélection.</p>'
        + '<div style="display:flex;gap:10px;flex-wrap:wrap;">'
        + '<button type="button" class="oph-op-action oph-op-action--solid" data-retry>Réessayer</button>'
        + '<a class="oph-op-action oph-op-action--ghost" href="mailto:contact@onepod.fr">Nous contacter</a>'
        + '</div></div>';
    }

    function paneNa() {
      var b = brand();
      var mailto = 'mailto:contact@onepod.fr?subject=' + encodeURIComponent('Quelle pièce est compatible ? (' + ((model() || {}).name || (b || {}).name || 'modèle') + ')');
      return '<div class="oph-finder__na"><h3>' + esc((model() || {}).name || '') + '</h3>'
        + '<p>' + esc(S.na) + '</p>'
        + '<p>Nous préférons ne rien vendre plutôt que de proposer une pièce incompatible. Envoyez-nous votre numéro de modèle et nous vérifierons pour vous.</p>'
        + '<div style="display:flex;gap:10px;flex-wrap:wrap;">'
        + '<a class="oph-op-action oph-op-action--solid" href="' + mailto + '">Envoyer mon numéro de modèle</a>'
        + (S.part === 'T' ? '<a class="oph-op-action oph-op-action--ghost" href="' + esc(CAT.tipsFallback) + '">Voir les accessoires</a>' : (b && b.collection ? '<a class="oph-op-action oph-op-action--ghost" href="' + esc(b.collection) + '">Voir toutes les pièces ' + esc(b.name) + '</a>' : ''))
        + '</div></div>';
    }

    function paneResultaat() {
      var b = brand() || {}, m = model() || {};
      var o = (opties() || [])[S.optIdx || 0] || {};
      if (S.laden || !S.prod) {
        return '<p style="margin:0;font-size:15px;color:var(--oph-mut);">Vérification du stock…</p>';
      }
      var p = S.prod;
      var offeredPart = o.pair ? 'Paire d’écouteurs sans boîtier' : partLabel(S.part);
      var replacementNote = o.pair
        ? 'Pour ce modèle, nous proposons les deux écouteurs ensemble, sans boîtier. Vérifiez que votre boîtier correspond au même modèle et à la même version, puis consultez les conditions de remplacement sur la fiche produit.'
        : 'Consultez les conditions de remplacement et la procédure de ce modèle sur la fiche produit avant de commander.';
      var variantLbl = p.kies ? 'À sélectionner sur la page produit' : (o.label || o.badge || (o.vt ? o.vt : 'Version standard'));
      var bz = bezorg();
      var stock;
      if (p.retired || (p.stockOnly && !p.beschikbaar)) {
        stock = '<p class="oph-result__stock is-out"><i></i>Cette pièce n’est plus proposée. Consultez sa fiche pour les précisions.</p>';
      } else if (!p.beschikbaar) {
        stock = '<p class="oph-result__stock is-out"><i></i>Temporairement épuisé : contactez-nous pour connaître le délai</p><p class="oph-result__ship">Nous pouvons vous en réserver un</p>';
      } else if (p.kies) {
        stock = '<p class="oph-result__stock">Disponibilité et délai selon la version : vérifiez votre choix sur la fiche produit.</p>';
      } else if (p.opVoorraad) {
        stock = '<p class="oph-result__stock is-ok"><i></i>En stock</p><p class="oph-result__ship">' + esc(bz.short) + '</p>';
      } else {
        stock = '<p class="oph-result__stock is-order"><i></i>Sur commande · livraison sous 10 jours ouvrés au plus tard</p>';
      }
      var acts;
      if (p.kies) {
        /* meerdere kleur-/firmware-varianten: keuze hoort op de productpagina */
        acts = '<a class="oph-op-action oph-op-action--solid" href="' + esc(p.url) + '">Sélectionner la version sur la page produit</a>';
      } else if (p.beschikbaar) {
        acts = '<button type="button" class="oph-op-action oph-op-action--solid" data-res-add>Ajouter au panier</button><a class="oph-op-action oph-op-action--ghost" href="' + esc(p.url) + '">Voir le produit</a>';
      } else {
        acts = '<a class="oph-op-action oph-op-action--solid" href="mailto:contact@onepod.fr?subject=' + encodeURIComponent('Disponibilité : ' + p.titel) + '">Nous contacter</a><a class="oph-op-action oph-op-action--ghost" href="' + esc(p.url) + '">Voir le produit</a>';
      }
      var gids = b.guide ? '<div class="oph-result__spec"><span>Guide d’appairage</span><b><a href="' + esc(b.guide) + '" style="color:var(--oph-accent);text-decoration:none;">Étape par étape ' + ARROW + '</a></b></div>' : '';
      return '<div class="oph-result">'
        + '<div><div class="oph-result__okwrap"><span class="oph-result__okic">' + CHECK.replace('width="15" height="15"', 'width="22" height="22"') + '</span><p class="oph-result__oktitle">Trouvé.</p></div>'
        + '<p class="oph-result__lead">' + replacementNote + '</p>'
        + '<div class="oph-result__specs">'
        + '<div class="oph-result__spec"><span>Vos écouteurs</span><b>' + esc(m.name || '') + '</b></div>'
        + '<div class="oph-result__spec"><span>Pièce</span><b>' + esc(offeredPart) + '</b></div>'
        + '<div class="oph-result__spec"><span>Version</span><b>' + esc(variantLbl) + '</b></div>'
        + (p.kies ? '<div class="oph-result__spec"><span>Compatibilité</span><b>Sélectionnez la couleur ou la version sur la page produit</b></div>' : '<div class="oph-result__spec"><span>Compatibilité</span><b>Vérifiez les conditions sur la fiche produit</b></div>')
        + gids + '</div>'
        + '<button type="button" class="oph-result__again" data-res-again>Recommencer</button></div>'
        + '<div class="oph-result__prod">'
        + '<div class="oph-result__pimg">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.titel) + '" loading="lazy">' : '') + '</div>'
        + '<div style="min-width:0;">'
        + '<p class="oph-result__pbrand">' + esc(b.name || '') + '</p>'
        + '<p class="oph-result__pname">' + esc(m.name || '') + ' · ' + esc(offeredPart.toLowerCase()) + (o.vt ? ' (' + esc(o.vt) + ')' : '') + '</p>'
        + '<p class="oph-result__pprice">' + (p.kies && p.prijsVanaf ? 'à partir de ' : '') + euro(p.prijs) + '</p>'
        + stock
        + '<div class="oph-result__acts">' + acts + '</div>'
        + '</div></div></div>';
    }

    /* ---- events per pane ---- */
    function koppelPane() {
      paneEl.querySelectorAll('[data-part]').forEach(function (b) {
        b.addEventListener('click', function () {
          S.part = b.dataset.part;
          S.step = S.brand ? 3 : 2; /* merk kan voorgeselecteerd zijn via de merktegels */
          render();
        });
      });
      paneEl.querySelectorAll('[data-brand]').forEach(function (b) {
        b.addEventListener('click', function () { S.brand = b.dataset.brand; S.step = 3; render(); });
      });
      koppelModellen();
      var ms = paneEl.querySelector('[data-model-search]');
      if (ms) ms.addEventListener('input', function () {
        var q = norm(ms.value);
        var lijst = brand().models.filter(function (m) { return modelMatch(m, q); });
        paneEl.querySelector('[data-model-grid]').innerHTML = modelTegels(lijst);
        var leeg = paneEl.querySelector('[data-model-empty]');
        if (leeg) leeg.hidden = lijst.length > 0;
        koppelModellen();
      });
      paneEl.querySelectorAll('[data-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          S.optIdx = Number(b.dataset.opt); S.done = true;
          laadProduct(opties()[S.optIdx]);
        });
      });
      var mt = paneEl.querySelector('[data-mnr-toggle]');
      if (mt) mt.addEventListener('click', function () {
        S.mnrOpen = !S.mnrOpen;
        var pnl = paneEl.querySelector('[data-mnr-panel]');
        pnl.hidden = !S.mnrOpen;
        mt.setAttribute('aria-expanded', S.mnrOpen ? 'true' : 'false');
        if (S.mnrOpen) { var inp = paneEl.querySelector('[data-mnr-input]'); if (inp) inp.focus(); }
      });
      var mgo = paneEl.querySelector('[data-mnr-go]');
      var minp = paneEl.querySelector('[data-mnr-input]');
      function doeMnr() {
        var fail = paneEl.querySelector('[data-mnr-fail]');
        var ok = mnrZoek(minp.value);
        if (!ok && fail) fail.hidden = !minp.value.trim();
      }
      if (mgo) mgo.addEventListener('click', doeMnr);
      if (minp) minp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doeMnr(); } });
      var ct = paneEl.querySelector('[data-casehelp-toggle]');
      if (ct) ct.addEventListener('click', function () { var p = paneEl.querySelector('[data-casehelp]'); p.hidden = !p.hidden; });
      var rt = paneEl.querySelector('[data-retry]');
      if (rt) rt.addEventListener('click', function () { var o = S.fout; S.fout = null; laadProduct(o); });
      var ra = paneEl.querySelector('[data-res-add]');
      if (ra) ra.addEventListener('click', function () { if (S.prod && S.prod.variantId) cartAdd(S.prod.variantId, ra); });
      var rg = paneEl.querySelector('[data-res-again]');
      if (rg) rg.addEventListener('click', resetAll);
    }

    function koppelModellen() {
      paneEl.querySelectorAll('[data-model]').forEach(function (b) {
        b.addEventListener('click', function () { kiesModel(brand().models[Number(b.dataset.model)]); });
      });
    }

    function resetAll() {
      S.seq++;
      Object.assign(S, { step: 1, part: null, brand: null, model: null, optIdx: null, done: false, mnrOpen: false, na: null, naSoort: null, prod: null, laden: false, fout: null });
      render();
    }

    backBtn.addEventListener('click', function () {
      S.seq++;
      if (S.done || S.na || S.fout) {
        S.done = false; S.na = null; S.naSoort = null; S.prod = null; S.fout = null; S.laden = false;
        var o = opties();
        S.step = (o && o.length > 1) ? 4 : 3;
        if (!brand()) S.step = 2;
        if (!S.model) S.step = brand() ? 3 : 2;
        render(); return;
      }
      if (S.step === 4) { S.step = 3; S.optIdx = null; }
      else if (S.step === 3) { S.step = 2; S.brand = null; S.model = null; S.mnrOpen = false; }
      else { S.step = 1; S.part = null; S.brand = null; S.model = null; }
      render();
    });

    /* voorselectie vanaf de merk- en categorietegels elders op de pagina */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-oph-open-finder]');
      if (!t) return;
      e.preventDefault();
      var merkId = t.dataset.merk || null;
      var part = t.dataset.part || null;
      resetAll();
      if (merkId && CAT.brands.some(function (b) { return b.id === merkId; })) S.brand = merkId;
      if (part) { S.part = part; S.step = S.brand ? 3 : 2; }
      render();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Deep links: ?piece=gauche|droit|boitier|embouts and ?marque=<brand id> preselect the first
       steps (used by the finder hub, the brand tiles and help pages). */
    (function vanUrl() {
      var q;
      try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
      var stukken = { gauche: 'L', droit: 'R', boitier: 'C', 'boîtier': 'C', embouts: 'T', l: 'L', r: 'R', c: 'C', t: 'T' };
      var piece = stukken[(q.get('piece') || '').toLowerCase()] || null;
      var merk = (q.get('marque') || '').toLowerCase();
      if (merk && CAT.brands.some(function (b) { return b.id === merk; })) S.brand = merk;
      if (piece) { S.part = piece; S.step = S.brand ? 3 : 2; }
    })();

    render();
  }

  /* ---------- init ---------- */
  function init() {
    reveal();
    faq();
    pcards();
    var f = document.querySelector('[data-oph-finder]');
    if (f && CAT) {
      finder(f);
    } else {
      /* geen finder of catalogus op deze pagina: merk-/kwijt-tegels sturen dan
         gewoon door naar de finder-hubpagina i.p.v. geruisloos niets te doen */
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-oph-open-finder]');
        if (!t) return;
        e.preventDefault();
        var merk = t.dataset.merk ? '?marque=' + encodeURIComponent(t.dataset.merk) : '';
        window.location.href = '/pages/trouver-mon-ecouteur' + merk + '#finder';
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
